import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  loading: boolean;
  reports: Report[] | null;
}


import { computed } from 'vue';
import uniqBy from 'lodash/uniqBy';

import { Report } from '@models';

import CardStat from '@components/Cards/CardStat.vue';

declare module 'vue/types/vue' {
  export interface Vue {
    CardModulesCompleted: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'CardModulesCompleted' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    loading: { type: Boolean },
    reports: null
  },
  setup(__props: any) {

const props = __props as {
  loading: boolean;
  reports: Report[] | null;
};

/**
 * `CardModulesCompleted` component properties.
 */


const modulesCompleted = computed(() => {
  return props.reports ? uniqBy(props.reports || [], 'module.id').length : null;
});

return { __sfc: true,props, modulesCompleted, CardStat }
}

})